import header from "./grundriss.webp";
import section1 from "./obergeschoss.jpg";
import section2 from "./einliegerwohnung.jpg";
import section3 from "./tuerschlossmitschluessel.jpg";
import section4 from "./haus-mit-einliegerwohnung.jpg";
import section5 from "./grundriss-auf-tablet.png";

export { header, section1, section2, section3, section4, section5 };
